import { Input } from '@/components/ui/input'
import { Textarea } from '@/components/ui/textarea'

interface Props {
    id: string
    value: string
    onChange: (value: string) => void
    // Multi-line long answer. Driven by the question's schema type ('textarea'),
    // set explicitly by the caller — no more guessing from the question wording.
    multiline?: boolean
}

export default function FreeFormInput({ id, value, onChange, multiline }: Props) {
    if (multiline) {
        return (
            <Textarea
                id={id}
                value={value}
                rows={3}
                className="max-w-2xl"
                onChange={(e) => onChange(e.target.value)}
            />
        )
    }

    return (
        <Input
            id={id}
            value={value}
            className="max-w-md"
            onChange={(e) => onChange(e.target.value)}
        />
    )
}
